enum GoogleMapsMarkerSizeEnum {
    TINY = "tiny",
    MID = "mid",
    SMALL = "small",
}

export default GoogleMapsMarkerSizeEnum;
